import type { Dispatch, AnyAction } from '@reduxjs/toolkit';
import Client_ from '../api/Client';
import { identifyUser, trackSignUp } from '../analytics/mixpanel';
import { userActions } from './slices/userSlice';

let userId: string | null = null;
let generation = 0;
let pending: Promise<any> | null = null;

export function setProfileIdentity(nextUserId: string | null, dispatch: Dispatch<AnyAction>) {
    if (nextUserId === userId && nextUserId !== null) return;
    userId = nextUserId;
    generation += 1;
    pending = null;
    dispatch(userActions.logoutUser());
    if (userId) dispatch(userActions.setUserLoading());
}

export function loadCurrentProfile(dispatch: Dispatch<AnyAction>): Promise<any> {
    if (!userId) return Promise.resolve(null);
    if (pending) return pending;
    const requestedGeneration = generation;
    pending = (async () => {
        const { err, res } = await Client_.client_().getUser();
        if (requestedGeneration !== generation) return null;
        if (err || !res?.success) {
            // A backend outage does not invalidate the Supabase session.
            dispatch(userActions.setUserLoaded());
            return null;
        }
        dispatch(userActions.setUser(res.result));
        const authFlow = localStorage.getItem('oauth_flow_type');
        if (authFlow === 'signup') trackSignUp(res.result, 'google');
        else identifyUser(res.result);
        if (authFlow) localStorage.removeItem('oauth_flow_type');
        return res.result;
    })().finally(() => {
        if (requestedGeneration === generation) pending = null;
    });
    return pending;
}
